import { getFileSize } from '.';

/**
 * Get a file size label, including the size and the unit. If the file size is too small to measure
 * in MB, measure it in KB.
 * @param bytes
 * @returns a label like '10MB' or '5KB'
 */
export const getFileSizeLabel = (bytes: number): string => {
    let fileSize = getFileSize({ bytes, unit: 'MB' });
    let fileSizeLabel = `${fileSize}MB`;

    if (fileSize === 0) {
        fileSize = getFileSize({ bytes, unit: 'KB' });
        fileSizeLabel = `${fileSize}KB`;
    }

    return fileSizeLabel;
};
